import { useMemo } from "react";
import { useFirestoreCollectionReadWrite } from "./useFirestoreCollectionReadWrite";
import { Carrier } from "@rebuild/shared/models";

export const useCarriers = () => {
	const { objects: carrierObjects, isLoading } = useFirestoreCollectionReadWrite<Carrier>("carrier_objects");
	const carriers = useMemo(() => carrierObjects.filter((carrier) => !carrier.disabled), [carrierObjects]);

	return { carriers, isLoading };
};
